import { isPartnerClientBrand } from '../contexts/ClientBrandingContext';

/**
 * The marketing home is only for signed-out house visitors.
 * Signed-in travellers go to My Trips. A Bespoke client never sees that
 * marketplace page — they get login/signup, then My Trips.
 */
export const brandedHomePath = (branding, signedIn) => {
  if (signedIn) return '/trips';
  if (isPartnerClientBrand(branding)) return '/login';
  return null;
};
